import { useCallback, useState } from "react";


/**
 * Utility to manage a boolean state.
 *
 * Returns [state, setFalse, setTrue]
 *
 * @param defaultState
 * @returns
 */
export function useBoolState(defaultState?: boolean): [boolean, () => void, () => void] {

    const [state, setState] = useState<boolean>(defaultState);
    const setFalse = useCallback(() => {
        setState(false);
    }, []);
    const setTrue = useCallback(() => {
        setState(true);
    }, []);
    return [state, setFalse, setTrue];
}